<template>
    <div @click="toggleChatWindow" id="chatButton" :class="{ 'active': isActive, 'bounce': isBounce, 'alert': hasNewMessages }"></div>
</template>

<script>
import {mapMutations, mapState} from 'vuex';

export default {
    name: 'ChatButton',
    methods: {
        ...mapMutations(["setChatOpen", "changeBounce"]),
        toggleChatWindow() {
            this.setChatOpen(!this.isChatOpened);
            this.changeBounce(false);
        }
    },
    computed: {
        ...mapState(['isChatOpened', 'bounce', 'hasNewMessages']),
        isActive() {
            return this.isChatOpened;
        },
        isBounce() {
            if (this.isActive != true) {
                return this.bounce;
            }
        }
    }
}
</script>
